<script setup lang="ts">
  import { computed } from 'vue';

  interface Variant {
    isPromotedAsNew: boolean,
    isPromotedAsDiscount: boolean,
    isMedicinalProduct: boolean,
  }

  interface Props {
    variant: Variant,
    icon?: boolean,
  }

  const props = withDefaults(defineProps<Props>(), {
    icon: false,
  });

  const isNew = computed(() => {
    return props.variant.isPromotedAsNew;
  });

  const isPromo = computed(() => {
    return props.variant.isPromotedAsDiscount;
  });

  const isMedicinalProduct = computed(() => {
    return props.variant.isMedicinalProduct;
  });
</script>
<template>
  <div v-if="isNew || isPromo || isMedicinalProduct" class="product-tags-wrapper">
    <SfProductTag :visible="isNew" tag-type="novelty" :icon="icon">
      {{ $t('SHOP.COMMON.LABEL.NEW') }}
    </SfProductTag>
    <SfProductTag :visible="isPromo" tag-type="discount" :icon="icon">
      {{ $t('SHOP.COMMON.LABEL.SALE') }}
    </SfProductTag>
    <SfProductTag :visible="isMedicinalProduct" icon tag-type="capsule">
      {{ $t('SHOP.COMMON.LABEL.MEDICINE') }}
    </SfProductTag>
  </div>
</template>
<style scoped lang="scss">
  .product-tags-wrapper {
    display: flex;
    gap: 0.25rem;
  }
</style>
